import type { DraftSection } from '../types';
import { sanitizeReportText } from './reportText';

/** One draft field as owner-facing text (internal terms cleaned up), or '' when absent. */
export function sectionText(sections: readonly DraftSection[], key: string): string {
  const section = sections.find((s) => s.key === key);
  if (!section) return '';
  return sanitizeReportText(Array.isArray(section.value) ? section.value.join('\n') : section.value);
}

/** A list field (checks) as plain items, numbering and bullets removed. */
export function sectionList(sections: readonly DraftSection[], key: string): string[] {
  const section = sections.find((s) => s.key === key);
  if (!section) return [];
  const items = Array.isArray(section.value) ? section.value : section.value.split('\n');
  return items.map((item) => sanitizeReportText(item.replace(/^\s*(?:[-*]|\d+[.)])\s*/, ''))).filter(Boolean);
}

/** A field exactly as the agent wrote it (values to paste must not be rewritten). */
export function sectionRaw(sections: readonly DraftSection[], key: string): string {
  const section = sections.find((s) => s.key === key);
  if (!section) return '';
  return Array.isArray(section.value) ? section.value.join('\n') : section.value;
}
